"use client";

import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { ErrorBoundary } from "./error-boundary";
import { ReactNode } from "react";

interface QueryBoundaryProps {
  children: ReactNode;
}

/**
 * Combines QueryErrorResetBoundary with ErrorBoundary
 * to properly handle and reset React Query errors
 */
export function QueryBoundary({ children }: QueryBoundaryProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => <ErrorBoundary onReset={reset}>{children}</ErrorBoundary>}
    </QueryErrorResetBoundary>
  );
}
